import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RestApiService } from '../angular-service/helper.httpServices';
const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root',
})
export class PostsService {
  private endPoint =
    environment.wordPressApiUrl + environment.wordPressApiEndPoint;
  public responseCache = new Map<String, any>();

  constructor(private http: RestApiService) {}

  getPosts(requestData: any) {
    return new Promise((resolve, reject) => {
      let url = this.endPoint + 'posts' + requestData;
      let cached = this.responseCache.get(url);
      if (cached) {
        resolve(cached);
      } else {
        this.http.get(url).subscribe(
          (response) => {
            this.responseCache.set(url, response);
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
      }
    });
  }

  getUserDetail(author: String) {
    return new Promise((resolve, reject) => {
      this.http.get(this.endPoint + 'users/' + author).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getMedia(featuredMediaId: String) {
    return new Promise((resolve, reject) => {
      this.http.get(this.endPoint + 'media/' + featuredMediaId).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
}
